export const OPEN_STATES_KEYS = {
    CHALLENGE: 'open',
    NPC: 'npc-open',
    DESIGNATION: 'designation-open',
}